import { getMixpanelDeviceId, trackGa4Event } from '../lib/utils';

let initialized = false;

export { getMixpanelDeviceId };

export function signupSourceForVariant(vKey, variantSignupSource) {
    if (variantSignupSource === 'desktop' || variantSignupSource === 'heictojpg') {
        return variantSignupSource;
    }
    if (vKey === 'desktop') return 'desktop';
    if (vKey === 'htj') return 'heictojpg';
    return null;
}

export function initPublicHomeAnalytics(pageVariant) {
    if (initialized) return;
    initialized = true;

    const variant = window.__PUBLIC_HOME_VARIANT || pageVariant;
    const superProps = {
        entry: 'public_home',
        page_variant: variant,
    };

    try {
        if (!window.__PUBLIC_HOME_VARIANT) {
            window.mixpanel?.register?.(superProps);
        }
    } catch { /* ignore */ }

    try {
        if (typeof window.gtag === 'function' && window.__PUBLIC_HOME_GA4_ID) {
            window.gtag('set', 'user_properties', { page_variant: variant, entry: 'public_home' });
        }
    } catch { /* ignore */ }

    const clearSuperProps = () => {
        try {
            window.mixpanel?.unregister?.('entry');
            window.mixpanel?.unregister?.('page_variant');
        } catch { /* ignore */ }
    };
    window.addEventListener('pagehide', clearSuperProps);
}

export function trackAnalyticsEvent(ev, props = {}) {
    const p = {
        entry: 'public_home',
        ...props,
    };

    try {
        window.mixpanel?.track?.(ev, p);
    } catch { /* ignore */ }

    try {
        if (!window.__PUBLIC_HOME_GA4_ID) return;
        trackGa4Event(ev, p);
    } catch { /* ignore */ }
}

export function identifyPublicHomeUser(userId) {
    if (!userId) return;
    try {
        window.mixpanel?.identify?.(String(userId));
    } catch { /* ignore */ }
    try {
        if (typeof window.gtag === 'function' && window.__PUBLIC_HOME_GA4_ID) {
            window.gtag('set', { user_id: String(userId) });
        }
    } catch { /* ignore */ }
}

export function trackHomeSignupClient({ method, created, source, pageVariant, useCase }) {
    if (!created) return;
    const deviceId = getMixpanelDeviceId();
    const props = {
        entry: 'public_home',
        method,
        ...(pageVariant ? { page_variant: pageVariant } : {}),
        ...(useCase ? { use_case: useCase } : {}),
        ...(source ? { source } : {}),
        ...(deviceId ? { $device_id: deviceId } : {}),
    };
    try {
        window.mixpanel?.track?.('user_signed_up', props);
    } catch { /* ignore */ }
    trackGa4Event('user_signed_up', props);
}

export function trackHomeAbandon(props) {
    const payload = {
        entry: 'public_home',
        ...props,
    };

    try {
        if (window.mixpanel?.track) {
            window.mixpanel.track('home_upload_abandoned', payload, { transport: 'sendBeacon' });
            return;
        }
    } catch { /* ignore */ }

    trackAnalyticsEvent('home_upload_abandoned', payload);
}
